import React from 'react';
import { XCircle, CheckCircle } from 'lucide-react';
export function BeforeAfterSection() {
  const rows = [{
    topic: 'Manipulación',
    before: 'Caes en trampas sin darte cuenta — en el trabajo, relaciones y compras',
    after: 'Detectas tácticas al instante y las neutralizas antes de que surtan efecto'
  }, {
    topic: 'Persuasión',
    before: 'Tus ideas no son escuchadas — luchas por ser tomado en serio',
    after: 'Persuades con historias y lenguaje preciso que mueven a la acción sin resistencia'
  }, {
    topic: 'Comunicación',
    before: 'Respondes de forma reactiva, sin estrategia ni intención real',
    after: 'Cada palabra es intencional — transmites autoridad y genera impacto genuino'
  }, {
    topic: 'Liderazgo',
    before: 'No entiendes por qué otros tienen influencia natural y tú no',
    after: 'Ejerces liderazgo auténtico que genera lealtad sin presión ni dependencia'
  }, {
    topic: 'Lectura social',
    before: 'Solo escuchas las palabras — los mensajes reales pasan desapercibidos',
    after: 'Lees microexpresiones y lenguaje no verbal con precisión clínica'
  }, {
    topic: 'Juego social',
    before: 'Juegas sin conocer las reglas — siempre un paso atrás',
    after: 'Entiendes las reglas del juego social y decides conscientemente cómo participar'
  }];
  return <section className="py-14 md:py-20 bg-[linear-gradient(160deg,#0c0600_0%,var(--negro)_100%)] border-t border-[rgba(201,151,43,.15)]" data-id="element-46">
      <div className="container" data-id="element-47">
        <div className="text-center max-w-[600px] mx-auto mb-8 md:mb-10" data-id="element-48">
          <div className="section-label justify-center" data-id="element-49">La transformación</div>
          <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco text-center" data-id="element-50">
            Así cambia tu realidad
            <br data-id="element-51" />
            <em className="text-dorado-claro not-italic italic" data-id="element-52">
              antes y después
            </em>{' '}
            de Código Oscuro
          </h2>
        </div>

        <div className="w-full rounded-[10px] overflow-hidden max-sm:block max-sm:overflow-x-auto" data-id="element-53">
          <table className="w-full border-collapse text-[.875rem] max-md:text-[.82rem]" data-id="element-54">
            <thead data-id="element-55">
              <tr data-id="element-56">
                <th className="bg-[#111] text-gris-texto w-[30%] text-left p-[18px_24px] text-[.78rem] font-extrabold tracking-[.15em] uppercase max-md:hidden" data-id="element-57">
                  Área
                </th>
                <th className="bg-[rgba(192,57,43,.2)] text-rojo-vivo text-center border-l border-[rgba(192,57,43,.25)] p-[18px_24px] text-[.78rem] font-extrabold tracking-[.15em] uppercase max-md:p-[12px_14px] max-md:text-[.7rem]" data-id="element-58">
                  <div className="flex items-center justify-center gap-1.5" data-id="element-59">
                    <XCircle className="w-4 h-4" data-id="element-60" /> Sin Código Oscuro
                  </div>
                </th>
                <th className="bg-[rgba(29,185,84,.15)] text-[#2ecc71] text-center border-l border-[rgba(29,185,84,.2)] p-[18px_24px] text-[.78rem] font-extrabold tracking-[.15em] uppercase max-md:p-[12px_14px] max-md:text-[.7rem]" data-id="element-61">
                  <div className="flex items-center justify-center gap-1.5" data-id="element-62">
                    <CheckCircle className="w-4 h-4" data-id="element-63" /> Con Código Oscuro
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-64">
              {rows.map((row, i) => <tr key={i} className="border-b border-[rgba(255,255,255,.05)] transition-colors duration-200 hover:bg-[rgba(201,151,43,.03)] last:border-b-0" data-id="element-65">
                  <td className="text-dorado-claro font-bold text-[.82rem] uppercase tracking-[.07em] bg-[#111] border-r border-[rgba(255,255,255,.06)] p-[16px_24px] align-middle max-md:hidden" data-id="element-66">
                    {row.topic}
                  </td>
                  <td className="text-crema-oscuro text-left bg-[rgba(139,26,26,.05)] border-l border-[rgba(192,57,43,.12)] p-[16px_24px] align-middle leading-[1.5] max-md:p-[12px_14px]" data-id="element-67">
                    <span className="inline-flex items-center gap-1.5" data-id="element-68">
                      <span className="text-rojo-vivo font-black shrink-0" data-id="element-69">
                        ✗
                      </span>
                      {row.before}
                    </span>
                  </td>
                  <td className="text-crema-oscuro text-left bg-[rgba(29,185,84,.04)] border-l border-[rgba(29,185,84,.12)] p-[16px_24px] align-middle leading-[1.5] max-md:p-[12px_14px]" data-id="element-70">
                    <span className="inline-flex items-center gap-1.5" data-id="element-71">
                      <span className="text-[#2ecc71] font-black shrink-0" data-id="element-72">
                        ✓
                      </span>
                      {row.after}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}